import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
export default function Cancel_Conformation({
  newPopUp,
  setNewPopUp,
  setCancelPopUp,
  setTrigger,
  trigger,
  data,
  propsData,
}) {
  const token = localStorage.getItem("nodeToken");

  const dispatch = useDispatch();

  const onSubmit = async () => {
    console.log("reqobj......", data);
    try {
      console.log("inputData....to be seen here..", data);

      const reqObject = {
        remarks_for_invoice_cancellation: data.remarks_for_invoice_cancellation,
        invoice_status: "INACTIVE",
        payment_type: "CANCEL_INVOICE",
      };
      const response = await nodeinstance.put(
        `/dashboard/visaSecurity/cancelflow/${propsData.id}`,
        reqObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setTrigger(!trigger);
        dispatch(
          setAppError({ msg: "Updated successfully.", color: "success" })
        );
        setCancelPopUp(false);
        setNewPopUp(false);
      }
    } catch (error) {
      console.log("error to be capctured here....", error);
      dispatch(setAppError({ msg: "Unable to update" }));
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          newPopUp ? "flex" : "hidden"
        }`}
      >
        {/* <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative"> */}
        <div className="max-w-lg w-full overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setNewPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div>
            <h1>Are you sure to cancel the Invoice</h1>
          </div>
          <div className="flex gap-3 w-full justify-center" style={{ m: 2 }}>
            <button
              className="p-2 bg-black text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
              onClick={() => {
                setNewPopUp(false);
              }}
            >
              {" "}
              <p>NO</p>
            </button>
            <button
              className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
              onClick={() => {
                onSubmit();
              }}
            >
              {" "}
              <p>YES</p>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
